import React from "react";
import AboutBackground from "../Assets/slide.png";
import AboutBackgroundImage from "../Assets/slide2.png";

const About = () => {
  return (
    <div id="About" className="relative bg-[#082028] py-12 md:py-20"> {/* Updated background color */}
      {/* Background image container */}
      <div className="absolute inset-0 z-0">
        <img src={AboutBackground} alt="Background" className="h-full w-full object-cover opacity-50" /> {/* Adjusted opacity for better readability */}
      </div>

      <div className="relative flex flex-row items-center justify-between z-10 container mx-auto  md:flex-row  px-6 md:px-12">
        {/* About section image */}
        <div className="w-full md:w-1/2 mb-6 md:mb-0 md:pr-8">
          <img src={AboutBackgroundImage} alt="About Ngolo Services" className="w-full h-auto rounded-lg shadow-lg" />
        </div>

        {/* Text container */}
        <div className="w-full md:w-1/2 bg-[#07182E] bg-opacity-90 p-2 md:p-10 rounded-lg shadow-lg"> {/* Updated background color */}
          <p className="text-[#D0B070] text-[22px] md:text-xl font-semibold mb-2"> {/* Updated text color */}
            Qui sommes-nous ?
          </p>
          <h1 className="text-xs md:text-5xl font-bold mb-4 text-[#D0B070]"> {/* Updated title color */}
            Ngolo Services
          </h1>
          <p className="text-gray-100 text-[9px] md:text-lg mb-4"> {/* Updated text color */}
            Basée sur une approche humaine et professionnelle, nous nous engageons à offrir un service de qualité qui allie
            expertise technique et créativité.
          </p>
          <p className="text-gray-100 text-[9px] md:text-lg mb-4"> {/* Updated text color */}
            Que ce soit pour l’entretien de vos équipements, la résolution de problèmes techniques ou l'amélioration de
            votre image de marque de plus un service livraison,
          </p>
          <p className="text-[#D0B070] text-[7px] md:text-xl font-semibold mb-6"> {/* Updated text color */}
            Ngolo Services est votre partenaire de confiance.
          </p>

          {/* Button */}
          <div className="flex justify-start">
            <a href="#Service" className="bg-[#D0B070] hover:bg-[#A89058] text-black md:py-2 md:px-6 py-1 px-3 md:text-xl text-[9px] rounded-full transition-colors duration-300"> {/* Updated button color */}
              Learn More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
